export default {
  ALPHA: 'alpha',
  ALPHA_DEALER: 'alpha-dealer',
  VEHICLE_ALPHA_MARKET: 'alpham',
  DEALER_ALPHA_MARKET: 'alpham-dealer',
  ACCELERATE_HOME_PAGE: 'accelerateHomePage',
  DEALER_INVENTORY: 'dealerInventory',
  DHS: 'dhs',
  ELOT: 'elot',
  HOT_CAR: 'hotcar',
  LISTING: 'listing',
  MY_ATC_SAVED_CAR: 'myATCsavedcar',
  NEW_CAR_BOOST: 'ncb',
  OTHER_VDP: 'otherVDP',
  PREVIOUSLY_VIEWED: 'PreviouslyViewed',
  RECOMMENDATIONS: 'recommendations',
  SIMILAR_INVENTORY: 'similar',
  SIMILAR_HYBRID: 'similar-hybrid',
  HYBRID: 'hybrid-listing',
  SPOTLIGHT: 'spotlight',
  SUPLEMENTAL: 'supplemental'
};